/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import { initializeFullOptions } from 'owa-options-store';
import { logUsage } from 'owa-analytics';
import { resetSearch, getQuery } from 'owa-options-search';
export var OPTION_NAVIGATION_KEY = 'OptionDirectNavigationv2';
export default orchestratorAction('showFullOptions', function showFullOptions(category, subcategory, option) {
    if (option) {
        // The option value is only set if the user navigated to a specific option,
        // rather than just opening the full options from the link at the bottom of the flex pane.
        // We should log the option chosen, as well as the current search term
        logUsage(OPTION_NAVIGATION_KEY, {
            optionKey: option,
            query: getQuery(),
        });
    }
    resetSearch(!!option /** Successful search **/);
    initializeFullOptions(category, subcategory, option);
});
//# sourceMappingURL=showFullOptions.js.map